import { ScanLine, Cpu, Layers, ShieldCheck } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { IMAGES } from "../data/site";

const TECH = [
    {
        icon: ScanLine,
        title: "TAC 3D Cone Beam",
        text: "Diagnosi tridimensionale ad altissima precisione per pianificare ogni impianto al decimo di millimetro.",
    },
    {
        icon: Cpu,
        title: "Chirurgia computer-guidata",
        text: "Posizionamento degli impianti pianificato al computer: interventi più sicuri, rapidi e meno invasivi.",
    },
    {
        icon: Layers,
        title: "Laboratorio odontotecnico interno",
        text: "Corone e protesi realizzate nella nostra struttura: tempi ridotti e controllo totale sulla qualità.",
    },
    {
        icon: ShieldCheck,
        title: "Sterilizzazione certificata",
        text: "Protocolli di sterilizzazione secondo gli standard europei, con tracciabilità completa di ogni strumento.",
    },
];

export const Technology = () => (
    <section
        id="tecnologia"
        data-testid="technology-section"
        className="py-24 sm:py-36 bg-charcoal border-y border-white/10"
    >
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
            <SectionHeading
                index="04"
                eyebrow="Tecnologia"
                title="Macchinari di ultima generazione."
                testId="technology-heading"
            />

            <Reveal delay={0.05}>
                <div
                    data-testid="tech-showcase-image"
                    className="mt-14 overflow-hidden rounded-2xl border border-white/10 aspect-[16/10] sm:aspect-[21/9]"
                >
                    <img
                        src={IMAGES.tac}
                        alt="Sala con ortopantomografo 3D e TAC della clinica"
                        loading="lazy"
                        className="w-full h-full object-cover grayscale hover:grayscale-0 hover:scale-105 transition-[filter,transform] duration-700"
                    />
                </div>
            </Reveal>

            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5">
                {TECH.map((item, i) => (
                    <Reveal key={item.title} delay={i * 0.07}>
                        <div
                            data-testid={`tech-card-${i}`}
                            className="group relative overflow-hidden rounded-2xl border border-white/10 bg-obsidian p-8 sm:p-10 h-full hover:border-gold/40 transition-colors duration-500"
                        >
                            <div className="absolute -top-24 -right-24 w-56 h-56 rounded-full bg-gold/10 blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
                            <div className="w-12 h-12 rounded-full border border-gold/40 flex items-center justify-center text-gold mb-7">
                                <item.icon size={22} strokeWidth={1.5} />
                            </div>
                            <h3 className="font-display text-2xl text-white font-light">
                                {item.title}
                            </h3>
                            <p className="mt-4 text-white/70 leading-relaxed text-sm sm:text-base">
                                {item.text}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
